if (!customElements.get('custom-remove-button')) {
  customElements.define('custom-remove-button', class CustomRemoveButton extends HTMLElement {
    constructor() {
      super();
      this.button = this.querySelector("button");
      this.miniCart = document.querySelector('mini-cart');
      this.initEventListeners();
    }
    initEventListeners(){
        this.button.addEventListener("click",this.removeItem.bind(this));
    }
   
    removeItem(evt){
        evt.preventDefault();
        const isMain = this.dataset.ismain;
        const bundleid = this.dataset.bundleid;
        const itemKey = this.dataset.key;
        const itemSelector = `cart-items .mini-cart__navigation li[data-bundleid="${bundleid}"][data-ismain="0"]`;
        this.button.setAttribute('disabled', true);
        this.button.classList.add('loading');
        let items = [];
        document.querySelectorAll(itemSelector).forEach((el) => {
          items.push({
            id: `${el.dataset.key}`,
            quantity:0
          });
        });
       items.push({
          id: `${itemKey}`,
          quantity:0
        });
        let updates = items.reduce((acc, { id, quantity }) => {
            acc[id] = quantity;
            return acc;
        }, {});
        const sections = this.miniCart.getSectionsToRender().map((section) => section.section);
        const body = JSON.stringify({
            updates,
            sections: sections,
            sections_url: window.location.pathname
        });
        
        fetch(`${window.routes.cart_update_url}`, {...fetchConfig(), ...{ body }})
        .then((response) => {
            return response.text();
        })
        .then((state) => {
            const parsedState = JSON.parse(state);
            this.classList.toggle('is-empty', parsedState.item_count === 0);
            const cartFooter = document.getElementById('main-cart-footer');

            if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);

            this.miniCart.getSectionsToRender().forEach((section => {
                const element = document.getElementById(section.id);
                if (element) {
                    const elementToReplace = element.querySelector(section.selector) || element;

                    if (elementToReplace && parsedState.sections[section.section]) {
                    elementToReplace.innerHTML =
                        this.miniCart.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
                    }
                }
            }));

            document.dispatchEvent(new CustomEvent('cart:updated', {
                detail: {
                    cart: state
                }
            }));
      })
      .catch(() => {
        
      })
        .finally(() => {
            this.button.classList.remove('loading');
            this.button.removeAttribute('disabled');
        });
    }
  });
}
if (!customElements.get('custom-gift-product')) {
  customElements.define('custom-gift-product', class CustomGiftProduct extends HTMLElement {
    constructor() {
      super();
      this.miniCart = document.querySelector('mini-cart');
      this.threshold = +this.dataset.threshold;
      this.threshold_product = this.dataset.thresholdproduct;
      this.product_id = this.dataset.id;
      this.product_variant_id = this.dataset.vid;
      
      // Enhanced processing state management
      this.isProcessing = false;
      this.pendingInit = false;
      this.lastCartState = null;
      this.cartStateHash = '';
      
      // Debounced init function to prevent rapid successive calls
      this.debouncedInit = this.debounce(this.init.bind(this), 150);
      
      // Bind event handler once
      this.handleCartUpdate = this.handleCartUpdate.bind(this);
      
      this.init();
    }

    // Debounce utility to prevent rapid successive calls
    debounce(func, wait) {
      let timeout;
      return function executedFunction(...args) {
        const later = () => {
          clearTimeout(timeout);
          func(...args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
      };
    }

    // Generate a simple hash of cart state to detect actual changes
    generateCartHash(cart) {
      const giftProducts = this.checkGiftProduct(cart);
      const relevantData = {
        itemCount: cart.item_count,
        thresholdQty: this.checkThresholdProduct(cart),
        giftCount: giftProducts.length,
        giftQuantities: giftProducts.map(item => ({ key: item.key, qty: item.quantity }))
      };
      return JSON.stringify(relevantData);
    }

    async init() {
      // Enhanced prevention of multiple simultaneous executions
      if (this.isProcessing) {
        this.pendingInit = true;
        return;
      }

      this.isProcessing = true;
      this.pendingInit = false;

      try {
        const cartRequest = await fetch('/cart.js');
        const cart = await cartRequest.json();
        
        // Check if cart state actually changed
        const newHash = this.generateCartHash(cart);
        if (this.cartStateHash === newHash) {
          console.log('Cart state unchanged, skipping gift logic');
          return;
        }
        this.cartStateHash = newHash;
        this.lastCartState = cart;

        const threshold_product_qty = this.checkThresholdProduct(cart);
        console.log(threshold_product_qty,"threshold_product_qty");
        const giftProductsInCart = this.checkGiftProduct(cart);
        const totalGiftQuantity = this.getTotalGiftQuantity(giftProductsInCart);
        const hasGiftInCart = giftProductsInCart.length > 0;
        const meetsThreshold = threshold_product_qty >= this.threshold;
        
        // Check if we already have the ideal state (exactly 1 gift with quantity 1)
        const hasIdealGiftState = giftProductsInCart.length === 1 && giftProductsInCart[0].quantity === 1;

        // Batch operations to minimize cart updates
        const operations = [];

        // If threshold is met and we already have exactly 1 gift with quantity 1, do nothing
        if (meetsThreshold && hasIdealGiftState) {
          console.log('Gift already in ideal state (1 item, quantity 1), skipping API call');
          return; // Exit early, no API calls needed
        }

        // Handle multiple gift products or quantities > 1
        if (giftProductsInCart.length > 1 || (giftProductsInCart.length === 1 && giftProductsInCart[0].quantity > 1)) {
          // If we have multiple gift items OR one gift with quantity > 1
          if (meetsThreshold) {
            // Keep only one gift with quantity 1, remove the rest
            operations.push(() => this.normalizeGiftQuantity(giftProductsInCart));
          } else {
            // Remove all gifts if threshold not met
            operations.push(() => this.removeAllGiftProducts(giftProductsInCart));
          }
        } else if (hasGiftInCart && !meetsThreshold) {
          // Remove gift if threshold not met (only if we have a gift)
          operations.push(() => this.removeGiftProduct(giftProductsInCart[0], 0));
        } else if (!hasGiftInCart && meetsThreshold) {
          // Add gift if threshold is met and no gift in cart
          operations.push(() => this.addGiftProduct());
        }

        // Execute operations sequentially to avoid conflicts
        for (const operation of operations) {
          await operation();
        }

      } catch (error) {
        console.error('Error in gift product initialization:', error);
      } finally {
        this.isProcessing = false;
        
        // Handle any pending init calls
        if (this.pendingInit) {
          setTimeout(() => this.debouncedInit(), 50);
        }
      }
    }

    // Get total quantity of all gift products
    getTotalGiftQuantity(giftProducts) {
      return giftProducts.reduce((total, item) => total + item.quantity, 0);
    }

    // Normalize gift quantity to exactly 1 (remove extras and set quantity to 1)
    async normalizeGiftQuantity(giftProducts) {
      return new Promise((resolve, reject) => {
        let updates = {};
        
        // Keep only the first gift product with quantity 1, remove all others
        giftProducts.forEach((item, index) => {
          if (index === 0) {
            // Set first gift to quantity 1
            updates[item.key] = 1;
          } else {
            // Remove all other gift products
            updates[item.key] = 0;
          }
        });

        const sections = this.miniCart?.getSectionsToRender().map((section) => section.section) || [];
        const body = JSON.stringify({
          updates,
          sections: sections,
          sections_url: window.location.pathname
        });
        
        fetch(`${window.routes.cart_update_url}`, {...fetchConfig(), body})
        .then((response) => response.text())
        .then((state) => {
          this.updateCartUI(state);
          resolve(JSON.parse(state));
        })
        .catch((error) => {
          console.error('Error normalizing gift quantity:', error);
          reject(error);
        });
      });
    }

    // Remove all gift products completely
    async removeAllGiftProducts(giftProducts) {
      return new Promise((resolve, reject) => {
        let updates = {};
        
        // Set all gift products to quantity 0
        giftProducts.forEach(item => {
          updates[item.key] = 0;
        });

        const sections = this.miniCart?.getSectionsToRender().map((section) => section.section) || [];
        const body = JSON.stringify({
          updates,
          sections: sections,
          sections_url: window.location.pathname
        });
        
        fetch(`${window.routes.cart_update_url}`, {...fetchConfig(), body})
        .then((response) => response.text())
        .then((state) => {
          this.updateCartUI(state);
          resolve(JSON.parse(state));
        })
        .catch((error) => {
          console.error('Error removing all gift products:', error);
          reject(error);
        });
      });
    }

    // Optimized batch removal for multiple gift products
    async batchRemoveGiftProducts(giftItems) {
      if (!giftItems || giftItems.length === 0) return;

      return new Promise((resolve, reject) => {
        let updates = {};
        
        // Build updates object for all items to remove
        giftItems.forEach(item => {
          updates[item.key] = 0;
        });

        const sections = this.miniCart?.getSectionsToRender().map((section) => section.section) || [];
        const body = JSON.stringify({
          updates,
          sections: sections,
          sections_url: window.location.pathname
        });
        
        fetch(`${window.routes.cart_update_url}`, {...fetchConfig(), body})
        .then((response) => response.text())
        .then((state) => {
          this.updateCartUI(state);
          resolve(JSON.parse(state));
        })
        .catch((error) => {
          console.error('Error batch removing gift products:', error);
          reject(error);
        });
      });
    }

    async removeGiftProduct(item, qty) {
      return new Promise((resolve, reject) => {
        let updates = {
          [item.key]: qty
        };

        const sections = this.miniCart?.getSectionsToRender().map((section) => section.section) || [];
        const body = JSON.stringify({
          updates,
          sections: sections,
          sections_url: window.location.pathname
        });
        
        fetch(`${window.routes.cart_update_url}`, {...fetchConfig(), body})
        .then((response) => response.text())
        .then((state) => {
          this.updateCartUI(state);
          resolve(JSON.parse(state));
        })
        .catch((error) => {
          console.error('Error removing gift product:', error);
          reject(error);
        });
      });
    }

    // Extract common UI update logic
    updateCartUI(state) {
      const parsedState = JSON.parse(state);
      this.classList.toggle('is-empty', parsedState.item_count === 0);
      
      const cartFooter = document.getElementById('main-cart-footer');
      if (cartFooter) {
        cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
      }

      this.miniCart?.getSectionsToRender().forEach((section => {
        const element = document.getElementById(section.id);
        if (element) {
          const elementToReplace = element.querySelector(section.selector) || element;
          if (elementToReplace && parsedState.sections[section.section]) {
            elementToReplace.innerHTML =
              this.miniCart.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
          }
        }
      }));

      document.dispatchEvent(new CustomEvent('cart:updated', {
        detail: { cart: state }
      }));
    }

    async addGiftProduct() {
      return new Promise((resolve, reject) => {
        // Use cached cart state if available and recent
        const checkPromise = this.lastCartState ? 
          Promise.resolve(this.lastCartState) : 
          fetch('/cart.js').then(response => response.json());

        checkPromise
        .then(cart => {
          const existingGifts = this.checkGiftProduct(cart);
          if (existingGifts.length > 0) {
            console.log('Gift already exists in cart, skipping addition');
            resolve(cart);
            return;
          }

          const items = [{
            id: this.product_variant_id,
            quantity: 1
          }];

          const sections = this.miniCart?.getSectionsToRender().map((section) => section.id) || [];
          const body = JSON.stringify({
            items: items,
            sections: sections,
            sections_url: window.location.pathname
          });

          return fetch(`${window.routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
            .then((response) => response.json())
            .then((response) => {
              if (response.status === 422) {
                document.dispatchEvent(new CustomEvent('ajaxProduct:error', {
                  detail: { errorMessage: response.description }
                }));
                reject(new Error(response.description));
                return;
              }

              this.miniCart?.renderContents(response);
              document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
                detail: { product: response }
              }));
              
              // Update cached cart state
              this.lastCartState = null; // Force refresh on next check
              resolve(response);
            });
        })
        .catch((e) => {
          console.error('Error adding gift product:', e);
          reject(e);
        });
      });
    }

    checkThresholdProduct(cart) {
      if(window.cartGiftThresholdProducts.length > 0){
        return cart.items
        .filter(item => window.cartGiftThresholdProducts.includes(item.product_id))
        .reduce((total, item) => total + item.quantity, 0);
      }else{
        return cart.items
        .filter(item => item.product_id == this.threshold_product)
        .reduce((total, item) => total + item.quantity, 0);
      }
      
    }

    checkGiftProduct(cart) {
      return cart.items.filter(item => item.product_id == this.product_id);
    }

    handleCartUpdate() {
      // Use debounced init to prevent rapid successive calls
      this.debouncedInit();
    }

    connectedCallback() {
      // Use the bound handler to avoid memory leaks
      document.addEventListener('cart:updated', this.handleCartUpdate);
    }

    disconnectedCallback() {
      // Properly clean up event listeners
      document.removeEventListener('cart:updated', this.handleCartUpdate);
      
      // Clear any pending timeouts
      this.isProcessing = false;
      this.pendingInit = false;
    }
  });
}